"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const update = (state) => ({ setState, getState }) => {
    if (state) {
        setState(Object.assign(Object.assign({}, getState()), state));
    }
};
exports.default = update;
